module.exports = __webpack_public_path__ + "img/3_146.b572a4be.png";